import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen, FiArrowRight, FiTarget, FiActivity, FiTrendingDown } from 'react-icons/fi';

const Step = ({ number, title, text, icon }) => (
  <div className="flex gap-4 p-4 rounded-2xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-700/50">
    <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white font-black shadow-lg">
      <SafeIcon icon={icon} className="w-5 h-5" />
    </div>
    <div>
      <h4 className="text-sm font-black uppercase tracking-tight mb-1 dark:text-white">
        Step {number}: {title}
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
        {text}
      </p>
    </div>
  </div>
);

const BeginnerGuide = () => {
  return (
    <div className="mt-12 space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-1.5 h-6 bg-blue-600 rounded-full" />
        <h3 className="text-xl font-black tracking-tight uppercase">Roadmap to Transformation</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Step 
          number="01" 
          icon={FiActivity}
          title="Find Your Baseline" 
          text="Your TDEE (Maintenance) is the 'break-even' point. Eat this amount to stay exactly the same weight. This is your metabolic anchor."
        />
        <Step 
          number="02" 
          icon={FiTarget}
          title="Pick Your Deficit" 
          text="For fat loss, aim for the 'Moderate Cut'. It's roughly 300-500 calories below maintenance—enough to lose fat without losing muscle."
        />
        <Step 
          number="03" 
          icon={FiBookOpen}
          title="Track & Log" 
          text="Use an app to track your food. Focus on hitting your Protein target first; it keeps you full and protects your metabolism."
        />
        <Step 
          number="04" 
          icon={FiTrendingDown}
          title="The 2-Week Audit" 
          text="Weight fluctuates daily. If your 7-day average weight doesn't move after 2 weeks, reduce your daily intake by another 100 calories."
        />
      </div>

      <div className="p-6 rounded-3xl bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30">
        <h4 className="text-sm font-bold text-blue-900 dark:text-blue-200 mb-2 flex items-center gap-2">
          💡 Pro Tip for Success
        </h4>
        <p className="text-xs text-blue-700 dark:text-blue-400 leading-relaxed">
          Don't try to be perfect. If you have a high-calorie day, just return to your blueprint the next morning. Consistency over 3 months beats perfection for 3 days.
        </p>
      </div>
    </div>
  );
};

export default BeginnerGuide;